export default __webpack_public_path__ + "static/media/wetez_reward_distribution.2050ef89.svg";